import { useGetProfileQuery } from "../../../store/messagingSlice"
import { ProfilePicture } from "../common/ProfilePicture/ProfilePicture"
import { useMessagingView } from "../hooks"
import { classNames } from "../utils"
import styles from "./MessageTyping.module.scss"

type MessageTypingProps = {
    username: string
}

export function MessageTyping({ username }: MessageTypingProps) {
    const { data: profile } = useGetProfileQuery(username || "")
    const { isDesktopConversation } = useMessagingView()

    return (
        <div
            className={classNames(styles.container, {
                [styles.compact]: isDesktopConversation,
                [styles.desktop]: isDesktopConversation,
            })}
        >
            <div className={styles.avatarContainer}>
                <ProfilePicture user={profile?.user} size={24} />
            </div>
            <div
                className={styles.typingIndicator}
                data-testid="typing-indicator"
            >
                <div className={styles.bubble} />
                <div className={styles.bubble} />
                <div className={styles.bubble} />
            </div>
        </div>
    )
}
